import * as React from 'react';
import { StyledBanner } from './styles/BannerStyles';
var Banner = function (_a) {
    var testId = _a.testId, _b = _a.height, height = _b === void 0 ? '56px' : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, children = _a.children, className = _a.className;
    return (React.createElement(StyledBanner, { className: className, "data-testid": testId, width: width, height: height, role: "banner" }, children));
};
export default Banner;
//# sourceMappingURL=Banner.js.map